import React from "react";
import BarraProductos from "../products/BarraProductos";
const Almacen = () => {
  return (
    <div>
        <BarraProductos />
    </div>
  );
};




export default Almacen;
